import Cookies from 'vue-cookies'
// 配置项目唯一前缀（确保不同项目不同）
const STORAGE_PREFIX = 'admin_clothing_cabinet_';
export function setStorage(key, value) {
  localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(value));
}
export function getStorage(key) {
  return JSON.parse(localStorage.getItem(`${STORAGE_PREFIX}${key}`))
}
export function removeStorage(key) {
  localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
}
export function setCookies(key, token) {
  Cookies.set(`${STORAGE_PREFIX}${key}`, token, 60 * 60 * 24)
}
export function getCookies(key) {
  return Cookies.isKey(`${STORAGE_PREFIX}${key}`) ? Cookies.get(`${STORAGE_PREFIX}${key}`) : null
}
export function removeCookies(key) {
  if (Cookies.isKey(`${STORAGE_PREFIX}${key}`)) {
    Cookies.remove(`${STORAGE_PREFIX}${key}`)
  }
}
export function setToken(token) {
  Cookies.set(`${STORAGE_PREFIX}_TOKEN`, token, 60 * 60 * 24)
  // Cookies.set("TOKEN_KEY", token, { expires: 1 }); // 1 天后过期 直接传天数（部分库支持）
}
export function getToken() {
  return Cookies.isKey(`${STORAGE_PREFIX}_TOKEN`) ? Cookies.get(`${STORAGE_PREFIX}_TOKEN`) : null
}
export function clearToken() {
  if (Cookies.isKey(`${STORAGE_PREFIX}_TOKEN`)) {
    Cookies.remove(`${STORAGE_PREFIX}_TOKEN`)
  }
}

export function checkAuthority(code) {
  let permissionList = getStorage("permissions")
  const permissionCodes = permissionList.map(item => item.code);
  return permissionCodes.includes(code);
}
// 校验手机号是否正确
export function validatePhone(rule, value, callback) {
  const phoneReg = /^1[3-9]\d{9}$/;
  if (!value) {
    return callback(new Error("请输入手机号"));
  }
  if (!phoneReg.test(value)) {
    callback(new Error("手机号格式不正确"));
  } else {
    callback();
  }
};
// 校验密码
export function validatePass(rule, value, callback) {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
  if (!value || value == '') {
    callback(new Error('请输入密码'));
  } else if (!reg.test(value)) {
    callback(new Error('密码应为8-16位字母与数字组合'));
  } else {
    callback();
  }
};
export function validatePassRepeat(rule, value, callback, password) {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
  if (!value || value == '') {
    callback(new Error('请输入密码'));
  } else if (!reg.test(value)) {
    callback(new Error('密码应为8-16位字母与数字组合'));
  } else if (password !== value) {
    callback(new Error('两次密码输入不一致'));
  } else {
    callback();
  }
};
/**
 * 云柜列表
 *      新增云柜：DEVICE_ADD
 *      编辑云柜：DEVICE_EDIT
 *      删除云柜：DEVICE_DELETE
 *      盘点云柜：DEVICE_STOCK
 *      重启云柜：DEVICE_RESTART
 *      查看日志：DEVICE_LOG
 *      升级云柜：DEVICE_UPGRADE
 *      初始化云柜：DEVICE_INIT
 *      导入云柜：DEVICE_IMPORT 
 *      导出云柜：DEVICE_EXPORT
 *      柜格详情：DEVICE_BOX_DETAIL
 *      新增柜格：DEVICE_BOX_ADD
 *      编辑柜格：DEVICE_BOX_EDIT
 *      删除柜格：DEVICE_BOX_DELETE
 *      柜格开锁：DEVICE_BOX_OPEN
 *      柜门状态：DEVICE_DOOR_STATUS
 *      释放柜格：DEVICE_BOX_RELEASE
 *      导入柜格：DEVICE_BOX_IMPORT
 * 区域列表
 *      新增区域：AREA_ADD
 *      编辑区域：AREA_EDIT
 *      删除区域：AREA_DELETE
 * 用户列表
 *      新增用户：USER_ADD 
 *      编辑用户：USER_EDIT
 *      删除用户：USER_DELETE
 *      导入用户：USER_IMPORT
 *      用户衣物：USER_CLOTHES
 *      新增用户衣物：USER_CLOTHES_ADD
 *      编辑用户衣物：USER_CLOTHES_EDIT
 *      删除用户衣物：USER_CLOTHES_DELETE
 *      导入用户衣物：USER_CLOTHES_IMPORT
 *      导出用户衣物：USER_CLOTHES_EXPORT
 * 部门列表
 *      新增部门：DEPARTMENT_ADD
 *      编辑部门：DEPARTMENT_EDIT
 *      删除部门：DEPARTMENT_DELETE
 *      导入部门：DEPARTMENT_IMPORT
 * 衣物分类
 *      新增衣物分类：CLOTHES_TYPE_ADD
 *      编辑衣物分类：CLOTHES_TYPE_EDIT
 *      删除衣物分类：CLOTHES_TYPE_DELETE
 * 衣物列表
 *      新增衣物：CLOTHES_ADD
 *      编辑衣物：CLOTHES_EDIT
 *      删除衣物：CLOTHES_DELETE
 *      导入衣物：CLOTHES_IMPORT
 *      衣物绑定用户：CLOTHES_BIND_USER
 * 权限管理
 *      新增权限：AUTHORITY_ADD
 *      编辑权限：AUTHORITY_EDIT
 *      删除权限：AUTHORITY_DELETE
 * 菜单管理
 *      新增菜单：MENU_ADD
 *      编辑菜单：MENU_EDIT
 *      删除菜单：MENU_DELETE
 * 角色管理
 *      新增角色：ROLE_ADD
 *      编辑角色：ROLE_EDIT
 *      删除角色：ROLE_DELETE
 * 企业管理
 *      新增单位：DEPART_ADD
 *      编辑单位：DEPART_EDIT
 *      删除单位：DEPART_DELETE
 * 参数配置
 *      新增参数：PARAM_ADD
 *      编辑参数：PARAM_EDIT
 *      删除参数：PARAM_DELETE
 * 用户管理
 *      新增用户：USER_SYSTEM_ADD
 *      编辑用户：USER_SYSTEM_EDIT
 *      删除用户：USER_SYSTEM_DELETE
 *      绑定设备：USER_SYSTEM_BIND_DEVICE
 *      重置密码：USER_SYSTEM_RSPWD
 * 开门记录
 *      查询开门记录：QUERY_OPEN_DOOR
 * 设备告警
 *      查询设备告警：QUERY_DEVICE_ALARM
 * 超时告警
 *    查询超时告警：QUERY_TIMEOUT_ALARM
 * 全部记录
 *    查询全部记录：QUERY_ALL_RECORD
 * 领取记录
 *    查询领取记录：QUERY_RECEIVE_RECORD
 * 回收记录 
 *    查询回收记录：QUERY_RECYCLE_RECORD
 * 投递记录
 *    查询投递记录：QUERY_STORE_RECORD
 * 释放记录
 *    查询释放记录：QUERY_RELEASE_RECORD
 * 记录统计
 *    查询记录统计：QUERY_RECORD_STATISTICS
 * 操作日志
 *    查询操作日志：QUERY_OPERATION_LOG
 */
/**
 * 设备管理 /deviceManage  menu_device.png
 *    云柜列表 /deviceList
 *    开门记录 /doorOpeningRecord
 *    区域列表 /deviceAreaList
 * 用户管理 /userManage  menu_user.png
 *    用户列表 /userList
 * 报警管理 /alarmManage  menu_alarm.png
 *    设备故障 /deviceFailure
 *    库存告警 /inventoryAlarm
 *    满桶告警 /fullbucketAlarm
 *    超时告警 /timeoutAlarm
 *    报警通知 /alarmNotification
 * 衣物管理 /clothingManage  menu_clothing.png
 *    衣物分类 /clothingClassify
 *    衣物列表 /clothingList
 *    衣物库存 /clothingInventory
 *    衣物规格 /clothingSpecification
 *    衣物种类 /clothingType
 * 记录管理 /recordsManage  menu_record.png
 *    全部记录 /allrecord
 *    入库记录 /inboundRecord
 *    出库记录 /outboundRecord
 *    领取记录 /receiveRecord
 *    回收记录 /recyclingRecord
 *    投递记录 /storageRecord
 *    释放记录 /releaseRecord
 *    统计报表 /statisticalReport
 * 工单管理 /sheetManage  menu_sheet.png
 *    领取工单 /outWorkSheet
 *    上架工单 /inWorkSheet
 * 盘点管理 /inventoryManage  menu_inventory.png
 *    盘点记录 /inventoryRecord
 *    盘点时间 /inventoryTime
 * 预警管理 /warningManage  menu_warning.png
 *    库存预警 /inventoryWarning
 * 广告管理 /advertManage  menu_ad.png
 *    广告分类 /advertSort
 *    广告列表 /advertList
 *    广告播放 /playList
 * 系统管理 /systemManage  menu_system.png
 *    用户管理 /systemUser
 *    角色管理 /systemRole
 *    权限管理 /systemAuthority
 *    菜单管理 /systemMenu
 *    企业管理 /systemEnterprise
 *    部门管理 /systemDepart
 *    操作日志 /systemLog
 *    参数配置 /systemParameterConfig
 */
